import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import AccountEditor from './AccountEditor';
import { useEditorReturn } from '../../hooks/useEditorReturn';

function AddAccount() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	// When opened from another editor's "crear nueva cuenta" typeahead link
	// (e.g. ContractEditor.jsx), returnTo carries the caller's path so we can
	// hand the newly created account back to it instead of always landing on
	// the accounts list.
	const returnTo = searchParams.get('returnTo');
	const { onReturn, returnLabel } = useEditorReturn();

	const handleCancel = () => navigate('/AdminScreen/accounts');
	const handleSaved = (savedAccountId) => {
		if (returnTo) {
			// Resolved against our own origin so an absolute/protocol-relative
			// returnTo can't navigate off-site — only pathname+search are used.
			const target = new URL(returnTo, window.location.origin);
			target.searchParams.set('accountId', savedAccountId);
			navigate(`${target.pathname}${target.search}`);
		} else {
			navigate(`/AdminScreen/accounts/account/${savedAccountId}`);
		}
	};

	return (
		<EntityList>
			<Helmet>
				<title>Nueva Cuenta</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Cuentas', to: '/AdminScreen/accounts' },
					{ label: 'Nueva Cuenta' },
				]}
				title='Nueva Cuenta'
				subtitle='Completá los datos principales de la cuenta.'
			/>
			<AccountEditor
				mode='create'
				onCancel={handleCancel}
				onSaved={handleSaved}
				onReturn={onReturn}
				returnLabel={returnLabel}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default AddAccount;
